import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { generateReport } from '../../app/store/actions/reports';
import FilterDefault from '../../components/filters/FilterDefault';
import OneClickButton from '../../components/form/button';
import Form from '../../components/form/form';
import addNotification from '../../components/notification';
import { PanelPage } from '../../components/pages/pages';
import { returnFiltersByRules } from './utils';
import ROUTES from '../../config/routes';
import ReportsBackgroundModal from '../../components/pages/reportsBackgroundModal';
import { getOrdersTypeList } from '../../app/store/actions/typeOrder';

class ReportOperationalPendingView extends React.PureComponent {
  constructor() {
    super();

    this.breadcrumb = [
      {
        value: (
          <>
            <i className="fas fa-home fa-fw m-t-10 m-r-5" />
            {' '}
            {I18n.t('BEE12' /* Início */)}
          </>
        ),
      },
      { value: I18n.t('BEE47' /* Relatórios */) },
      { value: I18n.t('BEE1963' /* KPIs */) },
      {
        value: I18n.t('BEE4471' /* Visão de Pendências Operacionais */),
        active: true,
      },
    ];

    this.state = {
      branchCodeFrom: '',
      branchCodeTo: '',
      deliveryDateFrom: '',
      deliveryDateTo: '',
      pendingAllocation: true,
      pendingCableCut: true,
      pendingPick: true,
      onPick: true,
      pendingCheck: true,
      pendingDock: true,
      pendingWaybill: true,
      pendingConsolidation: true,
      shop: true,
      finished: true,
      divergence: true,
      canceled: true,
      refund: true,
      pendingPickup: true,
      pendingSign: true,
      signChecked: true,
      startedCheck: true,
      pendingCheckInbound: true,
      finishedCheck: true,
      storage: true,
      stored: true,
      canceledInbound: true,
      checkAllCheckBoxes: true,
      checkAllCheckBoxesInbound: true,
      listOrderTypes: [],
      orderTypes: [],
    };
  }

  componentDidMount() {
    this.getOrdersTypeList();
  }

  getOrdersTypeList = async () => {
    await this.props.getOrdersTypeList();

    const uniqueTypes = [...new Set(this.props.orderTypeList.map((i) => i.type))];

    const listOrderTypes = uniqueTypes.map((type) => {
      this.setState({
        [`${type}`]: true,
      });

      return {
        value: type,
        label: type,
      };
    });

    listOrderTypes.push({
      value: 'all',
      label: I18n.t(
        'BEE3355', /* Todos os tipos de documento estão selecionados. */
      ),
    });

    this.setState({
      listOrderTypes,
      orderTypes: [
        {
          value: 'all',
          label: I18n.t(
            'BEE3355', /* Todos os tipos de documento estão selecionados. */
          ),
        },
      ],
    });
  };

  checkOrUncheckAllBoxesOutbound = (value) => {
    this.setState({
      pendingAllocation: value,
      pendingCableCut: value,
      pendingPick: value,
      onPick: value,
      pendingCheck: value,
      pendingDock: value,
      pendingWaybill: value,
      pendingConsolidation: value,
      shop: value,
      finished: value,
      divergence: value,
      canceled: value,
      refund: value,
      pendingPickup: value,
      checkAllCheckBoxes: value,
    });
  };

  checkOrUncheckAllBoxesInbound = (value) => {
    this.setState({
      checkAllCheckBoxesInbound: value,
      pendingSign: value,
      signChecked: value,
      startedCheck: value,
      pendingCheckInbound: value,
      finishedCheck: value,
      storage: value,
      stored: value,
      canceledInbound: value,
    });
  };

  handleSelectAllCheckBoxOutbound = () => {
    if (
      this.state.pendingAllocation
      && this.state.pendingCableCut
      && this.state.pendingPick
      && this.state.onPick
      && this.state.pendingCheck
      && this.state.pendingDock
      && this.state.pendingWaybill
      && this.state.pendingConsolidation
      && this.state.shop
      && this.state.finished
      && this.state.divergence
      && this.state.canceled
      && this.state.refund
      && this.state.pendingPickup
    ) {
      this.setState({
        checkAllCheckBoxes: true,
      });
    } else {
      this.setState({
        checkAllCheckBoxes: false,
      });
    }
  };

  handleSelectAllCheckBoxInbound = () => {
    if (
      this.state.pendingSign
      && this.state.signChecked
      && this.state.startedCheck
      && this.state.pendingCheckInbound
      && this.state.finishedCheck
      && this.state.storage
      && this.state.stored
      && this.state.canceledInbound
    ) {
      this.setState({
        checkAllCheckBoxesInbound: true,
      });
    } else {
      this.setState({
        checkAllCheckBoxesInbound: false,
      });
    }
  };

  setValue = async (attr, value) => {
    await this.setState({
      [`${attr}`]: value,
    });

    if (attr === 'checkAllCheckBoxes') {
      this.checkOrUncheckAllBoxesOutbound(value);
    }

    if (attr === 'checkAllCheckBoxesInbound') {
      this.checkOrUncheckAllBoxesInbound(value);
    }

    this.handleSelectAllCheckBoxOutbound();
    this.handleSelectAllCheckBoxInbound();
  };

  onGenerateSpreadsheet = () => {
    const {
      branchCodeFrom,
      branchCodeTo,
      deliveryDateFrom,
      deliveryDateTo,
      pendingAllocation,
      pendingCableCut,
      pendingPick,
      onPick,
      pendingCheck,
      pendingDock,
      pendingWaybill,
      pendingConsolidation,
      shop,
      finished,
      divergence,
      canceled,
      refund,
      pendingPickup,
      pendingSign,
      signChecked,
      startedCheck,
      pendingCheckInbound,
      finishedCheck,
      storage,
      stored,
      canceledInbound,
    } = this.state;

    const outboundStatusDocument = [];
    const inboundStatusDocument = [];
    const { location } = this.props;

    if (pendingAllocation) outboundStatusDocument.push('1');
    if (pendingCableCut) outboundStatusDocument.push('2');
    if (pendingPick) outboundStatusDocument.push('3');
    if (onPick) outboundStatusDocument.push('4');
    if (pendingCheck) outboundStatusDocument.push('5');
    if (pendingDock) outboundStatusDocument.push('6');
    if (pendingWaybill) outboundStatusDocument.push('7');
    if (pendingConsolidation) outboundStatusDocument.push('8');
    if (shop) outboundStatusDocument.push('9');
    if (finished) outboundStatusDocument.push('10');
    if (divergence) outboundStatusDocument.push('11');
    if (canceled) outboundStatusDocument.push('12');
    if (refund) outboundStatusDocument.push('13');
    if (pendingPickup) outboundStatusDocument.push('14');

    if (pendingSign) inboundStatusDocument.push('1');
    if (signChecked) inboundStatusDocument.push('2');
    if (pendingCheckInbound) inboundStatusDocument.push('3');
    if (startedCheck) inboundStatusDocument.push('4');
    if (finishedCheck) inboundStatusDocument.push('5');
    if (storage) inboundStatusDocument.push('6');
    if (stored) inboundStatusDocument.push('7');
    if (canceledInbound) inboundStatusDocument.push('9');

    const orderType = this.state.orderTypes.some((c) => c.value === 'all')
      ? this.state.listOrderTypes
        .filter((c) => c.value !== 'all')
        .map((c) => c.label)
      : this.state.orderTypes.map((c) => c.label);

    const filters = returnFiltersByRules([
      [
        'branchCode',
        { type: 'between', value: [branchCodeFrom, branchCodeTo] },
      ],
      [
        'deliveryDate',
        { type: 'between', value: [deliveryDateFrom, deliveryDateTo] },
      ],
      ['orderType', { type: 'in', value: orderType }],
      ['inboundStatus', { type: 'in', value: inboundStatusDocument }],
      ['outboundStatus', { type: 'in', value: outboundStatusDocument }],
    ]);

    if (!filters.outboundStatus && !filters.inboundStatus) {
      addNotification(
        'danger',
        I18n.t('BEE1759' /* Status do Documento */),
        I18n.t('BEE1198' /* Status deve ser informado! */),
        'top-right',
      );
      return;
    }

    if (Object.keys(filters).length > 1) {
      this.props.generateReport(
        I18n.t('BEE4471' /* Visão de Pendências Operacionais */).toLowerCase(),
        'xlsx',
        location.pathname,
        [{}],
        filters,
      );
      return;
    }

    addNotification(
      'danger',
      I18n.t('BEE2386' /* Verifique os Campos */),
      I18n.t('BEE2387' /* Nenhum campo foi preenchido */),
      'top-right',
    );
  };

  onSelectFilter = (newState) => {
    this.setState({ ...newState });
  };

  render() {
    const {
      branchCodeFrom,
      branchCodeTo,
      deliveryDateFrom,
      deliveryDateTo,
      pendingAllocation,
      pendingCableCut,
      pendingPick,
      onPick,
      pendingCheck,
      pendingDock,
      pendingWaybill,
      pendingConsolidation,
      shop,
      finished,
      divergence,
      canceled,
      refund,
      pendingPickup,
      pendingSign,
      signChecked,
      startedCheck,
      pendingCheckInbound,
      finishedCheck,
      storage,
      stored,
      canceledInbound,
      checkAllCheckBoxes,
      checkAllCheckBoxesInbound,
    } = this.state;

    const { location = {} } = this.props;

    return (
      <PanelPage
        breadcrumb={this.breadcrumb}
        title={I18n.t('BEE4471' /* Visão de Pendências Operacionais */)}
        wikiHelp={ROUTES.REPORT_HELP}
        content={(
          <div style={{ marginLeft: 20, marginRight: 20 }}>
            <FilterDefault
              stateToSave={this.state}
              route={location.pathname}
              onSelectFilter={this.onSelectFilter}
            />
            <div className="d-flex mb-md-4 mb-4 mt-4" />
            <div className="d-flex align-items-center mb-md-3 mb-1 mt-5">
              <h1 className="page-header mb-0">
                {I18n.t('BEE546' /* Filtros */)}
              </h1>
            </div>
            <hr />
            <div style={{ marginTop: 30 }}>
              <Form
                noPanel
                leftType
                setValue={this.setValue}
                inputs={(formContext) => [
                  formContext.createInputRange(
                    { from: branchCodeFrom, to: branchCodeTo },
                    { from: 'branchCodeFrom', to: 'branchCodeTo' },
                    `${I18n.t('BEE145' /* Filial */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  formContext.createDateInputRange(
                    { from: deliveryDateFrom, to: deliveryDateTo },
                    { from: 'deliveryDateFrom', to: 'deliveryDateTo' },
                    `${I18n.t('BEE444' /* Data de Entrega */)}:`,
                    { from: '__/__/____', to: '__/__/____' },
                  ),
                  formContext.createSelectDropDownMulti(
                    this.state.orderTypes,
                    `${I18n.t('BEE2796' /* Tipos de Documentos */)}:`,
                    'orderTypes',
                    this.state.listOrderTypes,
                    undefined,
                    ['col-md-2', 'col-md-4'],
                    false,
                  ),
                  formContext.createCustomCheckBoxes(
                    `${I18n.t('BEE438' /* Documentos de Entrada */)}`,
                    [
                      {
                        attr: 'checkAllCheckBoxesInbound',
                        value: checkAllCheckBoxesInbound,
                        label: I18n.t(
                          'BEE2385', /* Marcar ou Desmarcar todos */
                        ),
                      },
                      {
                        attr: 'pendingSign',
                        value: pendingSign,
                        label: I18n.t('BEE1783' /* Pendente de Placa */),
                      },
                      {
                        attr: 'signChecked',
                        value: signChecked,
                        label: I18n.t('BEE471' /* Conferência Placa Finalizada */),
                      },
                      {
                        attr: 'startedCheck',
                        value: startedCheck,
                        label: I18n.t('BEE473' /* Conferência Física Iniciada */),
                      },
                      {
                        attr: 'pendingCheckInbound',
                        value: pendingCheckInbound,
                        label: I18n.t('BEE472' /* Conferência Física Pendente */),
                      },
                      {
                        attr: 'finishedCheck',
                        value: finishedCheck,
                        label: I18n.t('BEE474' /* Conferência Física Finalizada */),
                      },
                      {
                        attr: 'storage',
                        value: storage,
                        label: I18n.t('BEE475' /* Em armazenagem */),
                      },
                      {
                        attr: 'stored',
                        value: stored,
                        label: I18n.t('BEE427' /* Armazenado */),
                      },
                      {
                        attr: 'canceledInbound',
                        value: canceledInbound,
                        label: I18n.t('BEE64' /* Cancelado */),
                      },
                    ],
                    `${I18n.t('BEE1087' /* Documentos de Saída */)}`,
                    [
                      {
                        attr: 'checkAllCheckBoxes',
                        value: checkAllCheckBoxes,
                        label: I18n.t(
                          'BEE2385', /* Marcar ou Desmarcar todos */
                        ),
                      },
                      {
                        attr: 'pendingAllocation',
                        value: pendingAllocation,
                        label: I18n.t('BEE1946' /* Pendente Alocação */),
                      },
                      {
                        attr: 'pendingCableCut',
                        value: pendingCableCut,
                        label: I18n.t('BEE1947' /* Pendente Corte de Cabos */),
                      },
                      {
                        attr: 'pendingPick',
                        value: pendingPick,
                        label: I18n.t('BEE1365' /* Pendente Separação */),
                      },
                      {
                        attr: 'onPick',
                        value: onPick,
                        label: I18n.t('BEE1367' /* Em Separação */),
                      },
                      {
                        attr: 'pendingCheck',
                        value: pendingCheck,
                        label: I18n.t('BEE1948' /* Pendente Conferência */),
                      },
                      {
                        attr: 'pendingDock',
                        value: pendingDock,
                        label: I18n.t('BEE1949' /* Pendente Docas */),
                      },
                      {
                        attr: 'pendingWaybill',
                        value: pendingWaybill,
                        label: I18n.t('BEE1773' /* Pendente Romaneio */),
                      },
                      {
                        attr: 'pendingConsolidation',
                        value: pendingConsolidation,
                        label: I18n.t('BEE1769' /* Pendente Consolidação */),
                      },
                      {
                        attr: 'shop',
                        value: shop,
                        label: I18n.t('BEE2255' /* Retira/Loja */),
                      },
                      {
                        attr: 'finished',
                        value: finished,
                        label: I18n.t('BEE1833' /* Finalizado */),
                      },
                      {
                        attr: 'divergence',
                        value: divergence,
                        label: I18n.t('BEE176' /* Divergência */),
                      },
                      {
                        attr: 'canceled',
                        value: canceled,
                        label: I18n.t('BEE64' /* Cancelado */),
                      },
                      {
                        attr: 'refund',
                        value: refund,
                        label: I18n.t('BEE1899' /* Devolvido */),
                      },
                      {
                        attr: 'pendingPickup',
                        value: pendingPickup,
                        label: I18n.t('BEE3687' /* Pendente Retirada */),
                      },
                    ],
                    `${I18n.t('BEE1759' /* Status do Documento */)}:`,
                  ),
                ]}
              />
            </div>
            <ReportsBackgroundModal />
          </div>
        )}
        footerContent={(
          <OneClickButton
            type="button"
            style={{ width: 'auto', padding: 10 }}
            className="btn btn-primary p-5 m-5"
            onClick={this.onGenerateSpreadsheet}
          >
            {I18n.t('BEE544' /* Gerar Planilha */)}
          </OneClickButton>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  orderTypeList: state.ordersTypes && state.ordersTypes.orderTypeList,
});
const mapDispatchToProps = (dispatch) => ({
  getOrdersTypeList: () => dispatch(getOrdersTypeList()),
  generateReport: (
    nameDoc,
    type,
    route,
    columns,
    filters,
  ) => dispatch(generateReport(nameDoc, type, route, columns, filters)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportOperationalPendingView);
